import 'select2';

export default () => {
	$( '.js-select-basic' ).select2();
};
